// extracted by mini-css-extract-plugin
var _1 = "UserProfileHeaderFooterSkeleton-modulefooter__JY2TT UserProfileHeaderFooter-modulefooter__QSi7F";
var _2 = "UserProfileHeaderFooterSkeleton-moduleskeletonButton__FdYad Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "footer", _2 as "skeletonButton" }
